import "./GallerySlideCard.scss";
import Link from "next/link";
import { getDifferenceDateBirth } from "@/utils/DateFormats";
import { GalleryI, PhotoI } from "@/interfaces/galleries/Galleries";
import { BsGrid } from "react-icons/bs";
import { useState } from "react";
import AddToCollectionModal from "@/components/Profile/AddToCollectionModal/AddToCollectionModal";
import { useModals } from "@/context/ModalContext";
import { nameSlug } from "@/utils/Functions/NameSlug";
const LikeIcon = "../../assets/images/icons/like.svg";
const DislikeIcon = "../../assets/images/icons/dislike.svg";
const CommentIcon = "../../assets/images/icons/comment.svg";
interface GallerySlideCardI {
  photo: PhotoI;
  number: number;
  totalPhotos: number;
  prevButton: any;
  nextButton: any;
  activeSwiperSlide: number;
  gallery: GalleryI;
  mosaicPhotos: PhotoI[];
}

function GallerySlideCard(props: GallerySlideCardI) {
  const { gallery, photo, mosaicPhotos } = props;
  const isMosaic = mosaicPhotos.length > 1;
  const { handleMosaic } = useModals();
  const photoDate = `${photo.year}-${photo.month}-${photo.day}`;
  const [showAdd, setShowAdd] = useState(false);
  return (
    <div className="gallery-slide-card">
      <div className="top-actions">
        <button
          className="inline-flex items-center justify-center rounded-md px-3 py-1.5 text-xs bg-black/50 hover:bg-black/40 text-white"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setShowAdd(true);
          }}
        >
          + to collection
        </button>
      </div>
      <div className="image-container relative">
        {props.nextButton && (
          <div
            className={
              "custom-swiper-vertical-button-next " +
              (props.activeSwiperSlide === props.totalPhotos - 1
                ? "d-none"
                : "")
            }
            style={photo.oldUrl ? { bottom: 70 } : undefined}
            onClick={() => props.nextButton.current.click()}
            role="button"
          ></div>
        )}
        {props.prevButton && (
          <div
            className={
              "custom-swiper-vertical-button-prev " +
              (props.activeSwiperSlide === 0 ? "d-none" : "")
            }
            style={photo.oldUrl ? { bottom: 105 } : undefined}
            onClick={() => props.prevButton.current.click()}
            role="button"
          ></div>
        )}
        <Link href={`${nameSlug(gallery.name)}/${photo.year}/${photo._id}`}>
          <img src={photo.url} alt={photo.alt || "gallery-" + photo.year} />
        </Link>
        {photo.oldUrl && (
          <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, backgroundColor: "rgba(0,0,0,0.75)", padding: "6px 8px", zIndex: 1 }}>
            <p style={{ fontSize: 10, color: "white", margin: 0, lineHeight: 1.4 }}>
              Original (unblurred) picture and more of that kind is available by
              this direct link to the owner&apos;s site.{" "}
              <span style={{ whiteSpace: "nowrap", fontSize: 10 }}>
                Source:{" "}
                {photo.sourceUrl ? (
                  <a
                    href={photo.sourceUrl}
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: "white", textDecoration: "underline", fontSize: 10 }}
                  >
                    {(() => {
                      try {
                        return new URL(photo.sourceUrl!).hostname;
                      } catch {
                        return photo.sourceUrl;
                      }
                    })()}
                  </a>
                ) : (
                  "TBD"
                )}
              </span>
            </p>
          </div>
        )}
      </div>
      <AddToCollectionModal
        open={showAdd}
        onClose={() => setShowAdd(false)}
        photoId={photo._id}
      />
      <div className="photo-info font-sans">
        <div className="c-row mb-1">
          <div className="action-container">
            <img src={LikeIcon} />
            <p>{photo.likes.length}</p>
          </div>
          <div className="action-container">
            <img src={DislikeIcon} />
            <p>{photo.dislikes.length}</p>
          </div>
          <div className="action-container">
            <img src={CommentIcon} />
            <p>{photo.comments}</p>
          </div>
          <div className="ms-auto flex gap-4">
            {isMosaic && (
              <div
                className=" z-30 w-8 h-8 cursor-pointer"
                onClick={() =>
                  handleMosaic({ show: true, photos: mosaicPhotos, gallery })
                }
              >
                <BsGrid className="w-8 h-8 z-50" />
              </div>
            )}
            <p className="font-extralight">
              {props.number} of {props.totalPhotos}
            </p>
          </div>
        </div>
        <div className="c-row">
          <p className="font-bold">{photo.year}</p>
        </div>

        <div className="c-row">
          <p className="font-bold">{photoDate}</p>
        </div>
        <div className="c-row">
          <p className="font-light">
            {getDifferenceDateBirth(photoDate, gallery!.dateStart)}
          </p>
        </div>
      </div>
    </div>
  );
}

export default GallerySlideCard;
